import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useBalanceConfig } from '../contexts/balanceSideContext'

interface UseBalanceLabelsResult {
  bt: (key: string, options?: Record<string, unknown>) => string
}

export const useBalanceLabels = (): UseBalanceLabelsResult => {
  const { t } = useTranslation()
  const { i18nPrefix } = useBalanceConfig()

  const bt = useCallback(
    (key: string, options?: Record<string, unknown>) => t(`${i18nPrefix}.${key}`, options),
    [t, i18nPrefix],
  )

  return useMemo(() => ({ bt }), [bt])
}
